import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { formatDateTime } from 'core/components/common/converters';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { IncidentDetailPatient } from 'sections/ube/features/IncidentDetail/useIncidentDetailForUbe';

type Props = {
  roscData: IncidentDetailPatient['treatments'][number]['data']['roscData'];
};

export const SpecialTreatmentTimeSeriesView = ({ roscData }: Props) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="特定行為(時系列)" />
        {roscData?.length ? (
          roscData.map(data => (
            <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
              <InfoDisplay
                title="特定行為(時間)"
                content={formatDateTime(data.recordedAt)}
              />
              <InfoDisplay title="特定行為" content={data.treatments?.[0]} />
              <InfoDisplay
                title="追加情報"
                content={data.additionalTreatmentInfo}
              />
              <InfoDisplay title="ROSC" content={data.rosc ? '該当' : ''} />
            </div>
          ))
        ) : (
          <div>
            <p>データが存在しません</p>
          </div>
        )}
      </div>
    </BorderedContainer>
  );
};
